import styled, { css } from "styled-components";

export const Container = styled.div<{
  hasFadeRight: boolean;
  hasFadeLeft: boolean;
}>`
  display: flex;
  overflow: hidden;
  position: relative;

  &::before,
  &::after {
    position: absolute;
    pointer-events: none;
    z-index: 10;
    top: 0;
    bottom: 0;
    width: 44px;
    background: linear-gradient(
      270deg,
      ${({ theme }) => theme.colorTokens.background.surface} 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  ${({ hasFadeLeft }) =>
    hasFadeLeft &&
    css`
      &::before {
        content: "";
        left: 0;
        transform: rotate(180deg);
      }
    `}

  ${({ hasFadeRight }) =>
    hasFadeRight &&
    css`
      &::after {
        content: "";
        right: 0;
      }
    `}
`;

export const List = styled.ul`
  display: flex;
  align-items: center;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ListItem = styled.li`
  display: flex;
  flex-shrink: 0;
`;
